import styled from "styled-components";

export const TableContainer = styled.div`
  background-color: #fff;
  /* margin-top: 1em; */
  /* box-shadow: 0px 4px 30px rgba(0, 0, 0, 0.08); */
  border-radius: 6px;
`;
